var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftPaginationFastArrowIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.056,
    height: 10.679,
    viewBox: "0 0 13.056 10.679",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-angle-double-left",
    "data-name": "Icon awesome-angle-double-left",
    d: "M7.753,11.072,11.865,6.96a.723.723,0,0,1,1.025,0l.683.683a.723.723,0,0,1,0,1.025l-2.912,2.918L13.577,14.5a.723.723,0,0,1,0,1.025l-.683.686a.723.723,0,0,1-1.025,0L7.756,12.1a.724.724,0,0,1,0-1.028ZM1.947,12.1l4.112,4.112a.723.723,0,0,0,1.025,0l.683-.683a.723.723,0,0,0,0-1.025L4.856,11.586,7.771,8.671a.723.723,0,0,0,0-1.025L7.087,6.96a.723.723,0,0,0-1.025,0L1.95,11.072a.724.724,0,0,0,0,1.028Z",
    transform: "translate(-1.234 -6.246)",
    fill: "#929292",
    stroke: "#fff",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftPaginationFastArrowIcon);
export default __webpack_public_path__ + "static/media/left-pagination-fast-arrow-icon.7c11be47fe33506613bb1242ca114ec9.svg";
export { ForwardRef as ReactComponent };